import { render, staticRenderFns } from "./ProductPackingSection.vue?vue&type=template&id=13276178&scoped=true&"
import script from "./ProductPackingSection.vue?vue&type=script&lang=js&"
export * from "./ProductPackingSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductPackingSection.vue?vue&type=style&index=0&id=13276178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13276178",
  null
  
)

export default component.exports